import React from 'react';
export function Courses() {
  const gradPhotos = ['https://cdn.magicpatterns.com/uploads/cgHdoSycri8RVqqj9ik2fE/instasaved-08-06-2026_(3).jpg', 'https://cdn.magicpatterns.com/uploads/kkarynhDPpzvB1AMQXTdXP/instasaved-08-06-2026_(4).jpg', 'https://cdn.magicpatterns.com/uploads/2wxyAmhy6mCMvbKRet7hQH/instasaved-08-06-2026_(5).jpg', 'https://cdn.magicpatterns.com/uploads/f9qS1vNhsVp7ctRMcfjeTj/instasaved-08-06-2026.jpg'];
  return <section id="cursos" className="w-full py-20 px-4 bg-background" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <div className="inline-block bg-gold text-background font-bold px-4 py-1 rounded uppercase tracking-widest text-sm mb-6" data-id="element-17">
            Cursos 2026 Disponibles
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-wide mb-8" data-id="element-18">
            Aprende el oficio de la barbería{' '}
            <span className="text-gold block mt-2" data-id="element-19">con los mejores</span>
          </h2>

          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-20">
            <span className="border border-muted text-muted px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-21">
              Cursos 2022
            </span>
            <span className="border border-muted text-muted px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-22">
              Cursos 2024
            </span>
            <span className="border border-muted text-muted px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-23">
              Cursos 2025
            </span>
            <span className="border border-gold text-gold px-4 py-1 rounded-full text-sm uppercase tracking-wider font-bold" data-id="element-24">
              Cursos 2026
            </span>
          </div>

          <a href="#contacto" className="inline-block bg-gold hover:bg-gold-hover text-background font-bold py-4 px-10 rounded uppercase tracking-wider transition-colors" data-id="element-25">
            Ver Cursos 2026
          </a>
        </div>

        <div className="mt-20" data-id="element-26">
          <h3 className="font-display text-3xl font-bold text-center mb-10 uppercase tracking-wide" data-id="element-27">
            Nuestros <span className="text-gold" data-id="element-28">Graduados</span>
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-29">
            {gradPhotos.map((photo, index) => <div key={index} className="aspect-[4/5] overflow-hidden rounded-lg border-2 border-[#222222] hover:border-gold transition-colors" data-id="element-30">
                <img src={photo} alt={`Graduado de Pueblo Barber ${index + 1}`} className="w-full h-full object-cover" data-id="element-31" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}